'use strict';

import numeral from 'numeral';

export const price = value =>  numeral(value).format('0,0.00');
